// The exported feature strings should match string values from cricket: https://github.com/globalvetlink/cricket/blob/dev/src/main/groovy/gvl/admin/FeatureName.groovy
export const FEATURE_ADS = 'Ads';
export const FEATURE_NVSL = 'NVSL';
export const FEATURE_RABIES = 'Rabies';
export const FEATURE_INTERNATIONAL = 'International';
export const FEATURE_VACCINE = 'Vaccine';
export const FEATURE_LICENSE_VALIDATION = 'LicenseValidation';
export const FEATURE_AGENTCVIENHANCEMENTS = 'AgentEnhancementFeature';
export const FEATURE_BILLINGPAGE = 'BillingPage';
